// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/icons/drop_down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/icons/drop_down_black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/icons/valid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/icons/error.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/icons/addTranscript.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconSelectContainer {
    position: absolute;
    right: 10px;
    top: 10px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
}

.iconSelectContainer:hover > div {
    background-color: #e6e7e9;
    cursor: pointer;
}

.iconSelectContainer:hover ul {
    height: 125px;
}

.iconSelectIcon {
    width: 34px;
    height: 34px;
    border-radius: 17px;
    background-color: transparent;
    background-repeat: no-repeat;
    background-size: 20px;
    background-position: center;
    transition: background-color 0.2s ease;
}

.iconSelectContainer ul {
    margin: 0;
    padding: 0;
    list-style: none;
    position: absolute;
    background: #e6e7e9;
    box-shadow: 0 0 1px #999;
    border-radius: 5px;
    top: 34px;
    right: 0;
    height: 0;
    overflow: hidden;
    transition: all 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.iconSelectContainer li {
    padding: 3px 5px;
    height: 25px;
    font-size: 14px;
    text-transform: uppercase;
    cursor: pointer;
}

.iconSelectContainer li:hover {
    background: #000;
    color: #fff;
}

.iconSelectContainer label {
    font-size: 14px;
    text-transform: uppercase;
}

.dropDown {
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    background: #1faeff;
    cursor: pointer;
    position: relative;
    min-width: 150px;
}

.dropDown.white {
    background: white;
    color: black;
    border: 1px solid #ddd;
    font-size: 14px;
}

.dropDown.small {
    font-size: 14px;
}

.dropDown p {
    cursor: pointer;
    margin: 0;
    padding: 10px 30px 10px 15px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
    background-position: right center;
    background-size: 30px;
}

.dropDown.white p {
    padding: 5px 15px 5px 10px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 25px;
}

.dropDown.small p {
    padding: 5px 15px 5px 10px;
    background-size: 25px;
}

.dropDown:hover p {
    background: none;
}

.dropDown ul {
    display: block;
    height: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    transition: height 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55);
    overflow: hidden;
    position: absolute;
    top: 100%;
    left: 0;
    background: #1faeff;
}

.dropDown.white ul {
    background: #fff;
}

.dropDown li {
    height: 30px;
    box-sizing: padding-box;
    padding: 5px 10px;
    text-align: left;
    background: transparent;
    transition: all 0.1s ease-in-out;
    border-right: 5px solid #1faeff;
    border-left: 5px solid #1faeff;
}

.dropDown.white li,
.dropDown.small li {
    border: 1px solid #ddd;
    height: 25px;
}

.dropDown li:hover {
    background: #fff;
    color: #1faeff;
}

.labelledInput,
.tagsInput {
    min-width: 300px;
    font-size: 20px;
    border-radius: 5px;
    border: 1px solid #bbb;
    padding: 5px 10px;
    margin-top: 5px;
    transition: border-color 0.2s ease;
}

.small .labelledInput {
    min-width: 100px;
    width: 100px !important;
    font-size: 18px;
    padding: 3px 6px;
    border-radius: 3px;
}

.labelledInput:focus,
.tagsInput:focus {
    border-color: #1faeff;
}

.labelledInputLabel {
    display: block;
    color: #1faeff;
    text-transform: capitalize;
    font-size: 0;
    transition: all 0.2s ease;
}

.labelledInputLabel.active {
    font-size: 14px;
}

.labelledInputLabel::after {
    content: ' :';
    display: inline;
}

.labelledInputLabel b {
    color: black;
}

textarea.labelledInput {
    font-family: Helvetica;
}

.tagsInput {
    width: 500px;
    display: flex;
    flex-wrap: wrap;
}

.StudioDetails .tagsInput {
    width: 100%;
}

.tagsInput input {
    border: none;
    flex: 1 1;
    font-size: 1rem;
    min-width: 50px;
}

.StudioDetails .tagsInput input{
    border: none;
    outline: none;
}

.fileInput {
    display: flex;
    align-items: center;
}

.fileInput.small {
    flex-direction: column-reverse;
}

.fileInput input {
    display: none;
}

.fileInput button,
button.button {
    padding: 10px 15px;
    background: #1faeff;
    border: none;
    cursor: pointer;
    color: white;
    font-size: 16px;
    font-weight: bold;
}

.button.small,
.fileInput.small button {
    padding: 4px 8px;
    font-weight: normal;
}

.fileInput button {
    background: white;
    color: #1faeff;
    border: 2px solid #1faeff;
}

.fileInput p {
    margin: 0 5px;
    display: flex;
    flex-direction: column;
}

.fileInput.small p {
    font-size: 16px;
}

.fileInput label {
    margin: 2px 0;
}

.fileInput label.valid::before,
.fileInput label.error::before {
    display: inline-block;
    position: relative;
    content: '';
    width: 16px;
    height: 16px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: contain;
    margin-right: 3px;
}

.fileInput label.error::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.transcriptsInput {
    padding: 0;
}

.transcriptInput {
    padding: 10px 20px;
    font-size: 18px;
    display: flex;
    border-bottom: 1px solid #ccc;
}

.transcriptInput:not(.new) label:first-of-type {
    flex: 1 1;
}

.transcriptInput.new {
    display: flex;
    flex-direction: column;
}

.transcriptInput.new > * {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 5px;
    align-items: center;
}

.transcriptInput:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.transcriptInput:last-child {
    border-bottom: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

.transcriptsInput .ext,
.transcriptsInput .default {
    background: #9300d6;
    border-radius: 5px;
    padding: 2px 4px;
    color: white;
    margin: 0 3px;
    font-weight: bold;
}

.transcriptsInput .default {
    background: #f20000;
}

.transcriptInput.addTranscript {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: 20px 20px;
    background-position: 15px 50%;
    background-repeat: no-repeat;
    padding-left: 45px;
    cursor: pointer;
}

.transcriptInput .remove {
    background: #f20000;
    color: #fff;
    border: none;
    cursor: pointer;
    padding: 0px 6px;
    font-weight: bold;
    font-size: 18px;
    width: 20px;
    height: 20px;
    overflow: hidden;
    line-height: 20px;
    margin-right: 10px;
    margin-left: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/Magor/Components/css/input.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,0DAA0D;AAC9D;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,4BAA4B;IAC5B,6DAA8D;IAC9D,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,yDAAgE;IAChE,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,WAAW;IACX,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,6DAA6D;IAC7D,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,0BAA0B;IAC1B,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,SAAO;IACP,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mDAAgD;IAChD,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,yDAAsD;AAC1D;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mDAAwD;IACxD,0BAA0B;IAC1B,6BAA6B;IAC7B,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B","sourcesContent":[".iconSelectContainer {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: center;\n}\n\n.iconSelectContainer:hover > div {\n    background-color: #e6e7e9;\n    cursor: pointer;\n}\n\n.iconSelectContainer:hover ul {\n    height: 125px;\n}\n\n.iconSelectIcon {\n    width: 34px;\n    height: 34px;\n    border-radius: 17px;\n    background-color: transparent;\n    background-repeat: no-repeat;\n    background-size: 20px;\n    background-position: center;\n    transition: background-color 0.2s ease;\n}\n\n.iconSelectContainer ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    position: absolute;\n    background: #e6e7e9;\n    box-shadow: 0 0 1px #999;\n    border-radius: 5px;\n    top: 34px;\n    right: 0;\n    height: 0;\n    overflow: hidden;\n    transition: all 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55);\n}\n\n.iconSelectContainer li {\n    padding: 3px 5px;\n    height: 25px;\n    font-size: 14px;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n\n.iconSelectContainer li:hover {\n    background: #000;\n    color: #fff;\n}\n\n.iconSelectContainer label {\n    font-size: 14px;\n    text-transform: uppercase;\n}\n\n.dropDown {\n    color: #fff;\n    font-weight: bold;\n    font-size: 16px;\n    background: #1faeff;\n    cursor: pointer;\n    position: relative;\n    min-width: 150px;\n}\n\n.dropDown.white {\n    background: white;\n    color: black;\n    border: 1px solid #ddd;\n    font-size: 14px;\n}\n\n.dropDown.small {\n    font-size: 14px;\n}\n\n.dropDown p {\n    cursor: pointer;\n    margin: 0;\n    padding: 10px 30px 10px 15px;\n    background: url(../../../assets/icons/drop_down.svg) no-repeat;\n    background-position: right center;\n    background-size: 30px;\n}\n\n.dropDown.white p {\n    padding: 5px 15px 5px 10px;\n    background-image: url(../../../assets/icons/drop_down_black.svg);\n    background-size: 25px;\n}\n\n.dropDown.small p {\n    padding: 5px 15px 5px 10px;\n    background-size: 25px;\n}\n\n.dropDown:hover p {\n    background: none;\n}\n\n.dropDown ul {\n    display: block;\n    height: 0;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    transition: height 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55);\n    overflow: hidden;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background: #1faeff;\n}\n\n.dropDown.white ul {\n    background: #fff;\n}\n\n.dropDown li {\n    height: 30px;\n    box-sizing: padding-box;\n    padding: 5px 10px;\n    text-align: left;\n    background: transparent;\n    transition: all 0.1s ease-in-out;\n    border-right: 5px solid #1faeff;\n    border-left: 5px solid #1faeff;\n}\n\n.dropDown.white li,\n.dropDown.small li {\n    border: 1px solid #ddd;\n    height: 25px;\n}\n\n.dropDown li:hover {\n    background: #fff;\n    color: #1faeff;\n}\n\n.labelledInput,\n.tagsInput {\n    min-width: 300px;\n    font-size: 20px;\n    border-radius: 5px;\n    border: 1px solid #bbb;\n    padding: 5px 10px;\n    margin-top: 5px;\n    transition: border-color 0.2s ease;\n}\n\n.small .labelledInput {\n    min-width: 100px;\n    width: 100px !important;\n    font-size: 18px;\n    padding: 3px 6px;\n    border-radius: 3px;\n}\n\n.labelledInput:focus,\n.tagsInput:focus {\n    border-color: #1faeff;\n}\n\n.labelledInputLabel {\n    display: block;\n    color: #1faeff;\n    text-transform: capitalize;\n    font-size: 0;\n    transition: all 0.2s ease;\n}\n\n.labelledInputLabel.active {\n    font-size: 14px;\n}\n\n.labelledInputLabel::after {\n    content: ' :';\n    display: inline;\n}\n\n.labelledInputLabel b {\n    color: black;\n}\n\ntextarea.labelledInput {\n    font-family: Helvetica;\n}\n\n.tagsInput {\n    width: 500px;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.StudioDetails .tagsInput {\n    width: 100%;\n}\n\n.tagsInput input {\n    border: none;\n    flex: 1;\n    font-size: 1rem;\n    min-width: 50px;\n}\n\n.StudioDetails .tagsInput input{\n    border: none;\n    outline: none;\n}\n\n.fileInput {\n    display: flex;\n    align-items: center;\n}\n\n.fileInput.small {\n    flex-direction: column-reverse;\n}\n\n.fileInput input {\n    display: none;\n}\n\n.fileInput button,\nbutton.button {\n    padding: 10px 15px;\n    background: #1faeff;\n    border: none;\n    cursor: pointer;\n    color: white;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.button.small,\n.fileInput.small button {\n    padding: 4px 8px;\n    font-weight: normal;\n}\n\n.fileInput button {\n    background: white;\n    color: #1faeff;\n    border: 2px solid #1faeff;\n}\n\n.fileInput p {\n    margin: 0 5px;\n    display: flex;\n    flex-direction: column;\n}\n\n.fileInput.small p {\n    font-size: 16px;\n}\n\n.fileInput label {\n    margin: 2px 0;\n}\n\n.fileInput label.valid::before,\n.fileInput label.error::before {\n    display: inline-block;\n    position: relative;\n    content: '';\n    width: 16px;\n    height: 16px;\n    background: url(../../../assets/icons/valid.svg);\n    background-size: contain;\n    margin-right: 3px;\n}\n\n.fileInput label.error::before {\n    background-image: url(../../../assets/icons/error.svg);\n}\n\n.transcriptsInput {\n    padding: 0;\n}\n\n.transcriptInput {\n    padding: 10px 20px;\n    font-size: 18px;\n    display: flex;\n    border-bottom: 1px solid #ccc;\n}\n\n.transcriptInput:not(.new) label:first-of-type {\n    flex: 1;\n}\n\n.transcriptInput.new {\n    display: flex;\n    flex-direction: column;\n}\n\n.transcriptInput.new > * {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    margin: 5px;\n    align-items: center;\n}\n\n.transcriptInput:first-child {\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n}\n\n.transcriptInput:last-child {\n    border-bottom: none;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n}\n\n.transcriptsInput .ext,\n.transcriptsInput .default {\n    background: #9300d6;\n    border-radius: 5px;\n    padding: 2px 4px;\n    color: white;\n    margin: 0 3px;\n    font-weight: bold;\n}\n\n.transcriptsInput .default {\n    background: #f20000;\n}\n\n.transcriptInput.addTranscript {\n    background: url(../../../assets/icons/addTranscript.svg);\n    background-size: 20px 20px;\n    background-position: 15px 50%;\n    background-repeat: no-repeat;\n    padding-left: 45px;\n    cursor: pointer;\n}\n\n.transcriptInput .remove {\n    background: #f20000;\n    color: #fff;\n    border: none;\n    cursor: pointer;\n    padding: 0px 6px;\n    font-weight: bold;\n    font-size: 18px;\n    width: 20px;\n    height: 20px;\n    overflow: hidden;\n    line-height: 20px;\n    margin-right: 10px;\n    margin-left: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
